// importing react componet
import * as React from 'react';

// importing react-redux component
import { connect } from 'react-redux';

// importing jquery
import * as jquery from 'jquery'

// 
import { Link } from 'react-router-dom';

// header
import Header from '../../sharedcomponents/header';

// loading
import { Loader } from '../../sharedcomponents/loader';

// actions
import { fetchProductionReports, fetchFilterData } from '../../store/productionReports/actions'

// columns for grid
import { productionReportsColumns } from './productionReportsColumns'

// logout
import { logout } from '../../store/login/action'

// import grid component
import ProductionReportsGrid from './productionReportGrid';
let thisContainer: any;

// class
class productionReports extends React.PureComponent<any, any>  {

  // initializing constructor
  constructor(props: any) {
    super(props);

    // initializing state
    this.state = {
      route: 'shipping',
      selectedReport: 'shipping',
      selectedFilter: 'All',
      ShippingRows: [],
      ShippingGrid: true,
      ShippingColumns: [],
      haveContentrows: [],
      haveContentGrid: false,
      haveContentColumns: [],
      NeedContentrows: [],
      NeedContentColumns: [],
      NeedContentGrid: false,
      OnHoldrows: [],
      OnHoldColumns: [],
      AggrData: {},
      OnHoldContentGrid: false,
      totalCount: 0,
      pageSizes: [10, 15, 30, 50],
      expandAll: false,
      listEmployee: [],
      listSalesPerson: [],
      listCSM: [],
      EnclosureCount: "",
      EnclosureCountGrid: []
    };

    // binding public fuction to this
    this.Sessionlogout = this.Sessionlogout.bind(this)
    this.triggerExpandCollapse = this.triggerExpandCollapse.bind(this);
    this.expandStatus = this.expandStatus.bind(this)
    this.populateData = this.populateData.bind(this)
    this.expandEachGridStatus = this.expandEachGridStatus.bind(this)
  }

  // handling logout click
  public Sessionlogout() {
    this.props.dispatch(logout());
  }

  // first method will call after page initialization
  public componentWillMount() {
    this.props.dispatch(fetchFilterData())
    const route = location.hash;
    const getCurrentRoute = route.toString().split("/");
    this.setState({
      selectedReport: `${getCurrentRoute[1]}`,
    })

    jquery(document).bind('click', (e) => {
      if(e.target.nodeName === "svg") {
        jquery(e.target).closest("tr").addClass("expandclicked")
      }
    });

  }

  //  componentDidMount method will be call after componentWillMount
  // componentwillMount has lot of funcationality to do
  // that's why using this method to prevent any overlap
  public componentDidMount() {
    thisContainer = this;
    this.props.dispatch(fetchProductionReports(this.state.selectedFilter));
  }


  // method will be called after recieving props
  public componentWillReceiveProps(props: any) {
    if (props.ProductionReportArrays) {
      this.setState({
        ShippingRows: props.ProductionReportArrays.Shipping,
        ShippingColumns: productionReportsColumns.shippingColumns,
        wareHouseColumns: productionReportsColumns.warehouseColumns,
        haveContentrows: props.ProductionReportArrays.HaveContent,
        haveContentColumns: productionReportsColumns.haveContentColumns,
        NeedContentrows: props.ProductionReportArrays.NeedContent,
        NeedContentColumns: productionReportsColumns.needContentColumn,
        OnHoldrows: props.ProductionReportArrays.OnHold,
        OnHoldColumns: productionReportsColumns.onHoldColumn,
        AggrData: props.ProductionReportArrays.ProjectAggrData,
        EnclosureCount: props.ProductionReportArrays.enclosureCountsArry
      })
    }

    // creating list of filter
    const companyDetails = props.FilterDropDown;
    if (companyDetails) {
      Object.keys(companyDetails.employee).map(key => {
        if (companyDetails.employee[key].emp_name !== '') {
          if (companyDetails.employee[key].status === 'CSM') {
            this.state.listCSM.push(<option key={companyDetails.employee[key].employee_id} value={[companyDetails.employee[key].emp_name, 'CSM']}>{companyDetails.employee[key].emp_name}</option>)
          } else if (companyDetails.employee[key].status === 'Production') {
            this.state.listEmployee.push(<option key={companyDetails.employee[key].employee_id} value={[companyDetails.employee[key].emp_name, 'prod']}>{companyDetails.employee[key].emp_name}</option>)
          }
        }
      });
      Object.keys(companyDetails.salesperson).map(key => {
        if (companyDetails.salesperson[key].emp_name !== '') {
          this.state.listSalesPerson.push(<option key={companyDetails.salesperson[key].sales_id} value={[companyDetails.salesperson[key].salesperson, 'sales']}>{companyDetails.salesperson[key].salesperson}</option>)
        }
      });
    }
  }

  // method after changing filter
  public getFileteredParams(event: any) {
    this.setState({
      selectedFilter: event.target.value
    })
    if (event.target.value && event.target.value !== "WH") {
      this.props.dispatch(fetchProductionReports(event.target.value));
    }
  }

  // method will look for dom and click expand/collapse button in each row
  public iterateTableClick(row: any, isExpand: boolean) {
    const expectedSvgOuterHtmlIE = '<path xmlns=\"http://www.w3.org/2000/svg\" d=\"M 12 8 l -6 6 l 1.41 1.41 L 12 10.83 l 4.59 4.58 L 18 14 Z\" />'
    const expectedSvgOuterHtml = '<path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"></path>';
    const tableTBodyPathString = `${row} > div > div > table > tbody`;
    const rowLenght = jquery(`${tableTBodyPathString} > tr`).length;
    const isIE = navigator.appVersion.indexOf('Trident/')
    // iterate through cells
    for (let index = 0; index < rowLenght; index++) {
      let svgOuterHtml;
      const rowExpandButton = `${tableTBodyPathString} > tr:nth-child(${index + 1}) td:nth-child(1) button`;
      const tableTrChildernNode = jquery(`${row} > div > div > table > tbody > tr:nth-child(${index + 1})`)
      const svgInnerTag = tableTrChildernNode["0"].firstChild.firstChild.firstChild.firstChild;
      if (svgInnerTag){
        const svgOuterTag = svgInnerTag.firstChild.lastChild;
      if (isIE > 0) {
        svgOuterHtml = new XMLSerializer().serializeToString(svgOuterTag)
        if (isExpand === false) {
          if (svgOuterHtml === expectedSvgOuterHtmlIE) {
            jquery(rowExpandButton).click();
          }
        } else {
          if (svgOuterHtml !== expectedSvgOuterHtmlIE) {
            jquery(rowExpandButton).click();
          }
        }
      } else {
        svgOuterHtml = svgOuterTag.outerHTML;
        if (isExpand === false) {
          if (svgOuterHtml === expectedSvgOuterHtml) {
            jquery(rowExpandButton).click();
          }
        } else {
          if (svgOuterHtml !== expectedSvgOuterHtml) {
            jquery(rowExpandButton).click();
          }
        }
      } 
      }
    }
  }

  

// method to manage expnad and collapse button
  public triggerExpandCollapse() {
    let isExpand: boolean;
    this.state.expandAll === false ? isExpand = true : isExpand = false;
    if (thisContainer.props.ProductionReportArrays.Shipping && thisContainer.state.ShippingGrid) {
      thisContainer.iterateTableClick("#green", isExpand);
    }
    if (thisContainer.props.ProductionReportArrays.HaveContent && thisContainer.state.haveContentGrid) {
      thisContainer.iterateTableClick("#yellow", isExpand);
    }
    if (thisContainer.props.ProductionReportArrays.NeedContent && thisContainer.state.NeedContentGrid) {
      thisContainer.iterateTableClick("#orange", isExpand);
    }
    if (thisContainer.props.ProductionReportArrays.OnHold && thisContainer.state.OnHoldContentGrid) {
      thisContainer.iterateTableClick("#red", isExpand);
    }
  }

  // setting expnad status
  public expandStatus() {
    this.state.expandAll === false ?
      this.setState({ expandAll: true }) :
      this.setState({ expandAll: false });
  }

  // method to handle expand all/ collapse all click
  public expandEachGridStatus() {
    this.expandStatus();
    this.triggerExpandCollapse();
  }

  public populateData(ele: any) {
    return <div key={`${Math.random()}`}><p>{ele.Enclosure}</p><p>{ele.Count}</p></div>
  }

  // rendering UI
  public render() {
    const loading = this.props.loading ? <Loader /> : '';
    const { path } = this.props.match;
    const aggrData = this.state.AggrData;

    // creating component for static data on top
    const aggrDataComp =
      aggrData !== undefined ?
        <div id="productionFields_info">
          <div className="production_reports">
            <span><b> PMF Total: {aggrData.totalProject} / {aggrData.totalUnit} / ${aggrData.totalRevenue !== undefined ? aggrData.totalRevenue.toLocaleString(undefined, { minimumFractionDigits: 2 }) : "0.00"}</b></span>< br />
          </div>

          <div className="production_reports">
            <span><b>Shipping This Month: </b> {aggrData.shippingThisMonthProject} / {aggrData.shippingThisMonthUnits} / ${aggrData.shippingThisMonthRevenue !== undefined ? aggrData.shippingThisMonthRevenue.toLocaleString(undefined, { minimumFractionDigits: 2 }) : "0.00"}</span> < br />
            < br />
            <span><b>Have Content: </b> {aggrData.haveContentProject} / {aggrData.haveContentUnits} / ${aggrData.haveContentRevenue !== undefined ? aggrData.haveContentRevenue.toLocaleString(undefined, { minimumFractionDigits: 2 }) : "0.00"}</span>< br />
            <span><b>Need Content: </b> {aggrData.needContentProject} / {aggrData.needContentUnit} / ${aggrData.needContentRevenue !== undefined ? aggrData.needContentRevenue.toLocaleString(undefined, { minimumFractionDigits: 2 }) : "0.00"}</span>< br />
          </div>

          <div className="production_reports">
            <span><b>Later: </b> {aggrData.laterProject} / {aggrData.laterUnite} / ${aggrData.laterRevenue !== undefined ? aggrData.laterRevenue.toLocaleString(undefined, { minimumFractionDigits: 2 }) : "0.00"}</span>< br />
            <span>Shipping Later: {aggrData.laterShippingLaterProject} / {aggrData.laterShippingLaterUnite} / ${aggrData.laterShippingLaterUnite !== undefined ? aggrData.laterShippingLaterUnite.toLocaleString(undefined, { minimumFractionDigits: 2 }) : "0.00"}</span>< br />
            <span>On Hold: {aggrData.laterOnHoldProject} / {aggrData.laterOnHoldUnite} / ${aggrData.laterOnHoldRevenue !== undefined ? aggrData.laterOnHoldRevenue.toLocaleString(undefined, {minimumFractionDigits: 2 }) : "0.00"}</span>< br />
          </div>
          
          <div className="production_reports">
            <span><b>Time in PMF:</b></span>< br />
            <span>Sold Same Month : {aggrData.soldThisMonthProject} / {aggrData.soldThisMonthUnit} / ${aggrData.soldThisMonthRevenue !== undefined ? aggrData.soldThisMonthRevenue.toLocaleString(undefined, { minimumFractionDigits: 2 }) : "0.00"}</span>< br />
            <span>Sold Prev Month : {aggrData.soldPrevMonthProject} / {aggrData.soldPrevMonthUnit} / ${aggrData.soldPrevMonthRevenue !== undefined ? aggrData.soldPrevMonthRevenue.toLocaleString(undefined, { minimumFractionDigits: 2 }) : "0.00"}</span>< br />
            <span>Sold 2 Months Prev : {aggrData.soldTwoMonthPrevProject} / {aggrData.soldTwoMonthPrevUnit} / ${aggrData.soldTwoMonthPrevRevenue !== undefined ? aggrData.soldTwoMonthPrevRevenue.toLocaleString(undefined, { minimumFractionDigits: 2 }) : "0.00"}</span>< br />
            <span>3 Months + : {aggrData.soldThreeMonthPlusProject} / {aggrData.soldThreeMonthPlusUnit} / ${aggrData.soldThreeMonthPlusRevenue !== undefined ? aggrData.soldThreeMonthPlusRevenue.toLocaleString(undefined, { minimumFractionDigits: 2 }) : "0.00"}</span>< br />
          </div>
          <div className="clear"></div>
        </div>
        : '';

    return (
      <div>
        {loading}
        <Header />
        <div className="header-bottom">
          <button
            className="btn right-float"
            onClick={() => this.Sessionlogout()}
          >Logout</button>
        </div>
        {aggrDataComp}
        {this.state.EnclosureCountGrid}
        <div className="content-body">
          <div className="production-filter">
            <select onChange={(e) => {
              this.getFileteredParams(e)
              if (this.state.expandAll === true) {
                this.triggerExpandCollapse();
                this.setState({ expandAll: false });
              }

            }} value={this.state.selectedFilter} >
              <option value="All">All</option>
              <optgroup label="Sales Region">
                {this.state.listSalesPerson}
              </optgroup>
              <optgroup label="CSM">
                {this.state.listCSM}
              </optgroup>
              <optgroup label="Production">
                {this.state.listEmployee}
              </optgroup>
              <optgroup label="Warehouse">
                <option value="WH">WH</option>
              </optgroup>
            </select>
            <ul>
              <li
                className={this.state.ShippingGrid ? 'active' : ''}
                onClick={
                  (e) => {
                    const gridStatus = this.state.ShippingGrid ? false : true
                    if (this.state.expandAll === true) {
                      this.triggerExpandCollapse()
                    }
                    this.setState({ ShippingGrid: gridStatus, expandAll: false });
                  }} >
                <Link to={`${path}/${this.state.selectedFilter}`}>
                  Shipping
                </Link>
              </li>
              <li
                className={this.state.haveContentGrid ? 'active' : ''}
                onClick={
                  (e) => {
                    const gridStatus = this.state.haveContentGrid ? false : true
                    if (this.state.expandAll === true) {
                      this.triggerExpandCollapse()
                    }
                    this.setState({ haveContentGrid: gridStatus, expandAll: false });
                  }} >
                <Link to={`${path}/${this.state.selectedFilter}`} className="active">
                  Have Content
                </Link>
              </li>
              {this.state.selectedFilter === "WH" ? "" :
                <li
                  className={this.state.NeedContentGrid ? 'active' : ''}
                  onClick={
                    (e) => {
                      const gridStatus = this.state.NeedContentGrid ? false : true
                      if (this.state.expandAll === true) {
                        this.triggerExpandCollapse()
                      }
                      this.setState({ NeedContentGrid: gridStatus, expandAll: false });
                    }} >
                  <Link to={`${path}/${this.state.selectedFilter}`}>
                    Need Content
                </Link>
                </li>
              }
              {this.state.selectedFilter === "WH" ? "" :
                <li
                  className={this.state.OnHoldContentGrid ? 'active' : ''}
                  onClick={
                    (e) => {
                      const gridStatus = this.state.OnHoldContentGrid ? false : true;
                      if (this.state.expandAll === true) {
                        this.triggerExpandCollapse()
                      }
                      this.setState({ OnHoldContentGrid: gridStatus, expandAll: false });
                    }} >
                  <Link to={`${path}/${this.state.selectedFilter}`}>
                    On Hold
                </Link>
                </li>
              }
            </ul>
            <div className="clear"></div>
          </div>

          <div className="content-section" id="production_reports">
            <div className="grid-style">
              <button
                className="active expandAllButton"
                onClick={() => {
                  this.expandStatus();
                  this.triggerExpandCollapse()
                }}
              >
                {this.state.expandAll ? "Collapse All" : "Expand All"}
              </button>
              {
                this.state.ShippingGrid ? (
                  this.state.selectedFilter === "WH" ?
                    <ProductionReportsGrid
                      tablecolor="green"
                      rows={this.state.ShippingRows === undefined ? [] : this.state.ShippingRows}
                      columns={this.state.wareHouseColumns}
                      expandAllCallback={this.expandEachGridStatus}
                      expandAllStatus={this.state.expandAll}
                    />
                    :
                    <ProductionReportsGrid
                      tablecolor="green"
                      rows={this.state.ShippingRows === undefined ? [] : this.state.ShippingRows}
                      columns={this.state.ShippingColumns}
                      expandAllCallback={this.expandEachGridStatus}
                      expandAllStatus={this.state.expandAll}
                    />
                ) : ""
              }
              <br />
              {
                this.state.haveContentGrid ? (
                  <ProductionReportsGrid
                    tablecolor="yellow"
                    rows={this.state.haveContentrows || []}
                    columns={this.state.haveContentColumns}
                    expandAllCallback={this.expandEachGridStatus}
                    expandAllStatus={this.state.expandAll}
                  />
                ) : ""
              }
              <br />
              {this.state.NeedContentGrid ? (
                <ProductionReportsGrid
                  tablecolor="orange"
                  rows={this.state.NeedContentrows || []}
                  columns={this.state.NeedContentColumns}
                  expandAllCallback={this.expandEachGridStatus}
                  expandAllStatus={this.state.expandAll}
                />
              ) : ""
              }
              <br />
              {
                this.state.OnHoldContentGrid ? (
                  <ProductionReportsGrid
                    tablecolor="red"
                    rows={this.state.OnHoldrows || []}
                    columns={this.state.OnHoldColumns}
                    expandAllCallback={this.expandEachGridStatus}
                    expandAllStatus={this.state.expandAll}
                  />
                ) : ""
              }
            </div>
            <div>
              {this.state.selectedFilter === "WH" ?
                <div className="enclosure-count">
                  {
                    this.state.EnclosureCount === "" ? "" : this.state.EnclosureCount.map((item: any) => this.populateData(item))
                  }
                </div>
                : ""
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// mapping all the recieved prop to local
const mapStateToProps = (state: any) => ({
  ProductionReportArrays: state.productionReports.ProductionReportArrays,
  FilterDropDown: state.productionReports.FilterDropDown,
  loading: state.loading.getProductionReportsStatus
});
export default connect(mapStateToProps)(productionReports);



// WEBPACK FOOTER //
// ./src/components/Production/productionReports.tsx